export default {
  // Primary variants ----------------------------------------->
  //40px
  primary:
    "h-[40px] flex items-center justify-center bg-primary hover:bg-primary_hov text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  //44px
  primary_m:
    "w-auto h-[40px] lg:h-[44px] flex items-center justify-center bg-primary hover:bg-primary_hov text-white text-lg font-semibold whitespace-nowrap rounded-full px-5 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //56px
  primary_l:
  "w-auto h-[48px] lg:h-[56px] flex items-center justify-center bg-primary hover:bg-primary_hov text-white text-lg lg:text-xl font-bold rounded-full px-8 lg:px-10 transition-colors ease-in-out",

  //40px inv
  primary_inv:
    "h-[40px] flex items-center justify-center bg-white text-primary hover:text-primary_dk font-bold rounded-full hover:shadow-lg px-8 lg:px-10 transition ease-in-out",

  //56px inv
  primary_l_inv:
    "w-auto h-[48px] lg:h-[56px] flex items-center justify-center gap-2 bg-white hover:scale-105 text-link text-[20px] font-semibold whitespace-nowrap rounded-full px-7 lg:px-[34px] transition",

  //40px red
  primary_red:
    "h-[40px] flex items-center justify-center bg-error hover:bg-error/90 text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  // Secondary variants ----------------------------------------->
  //40px
  secondary:
    "h-[40px] flex items-center justify-center border border-primary text-primary hover:text-white hover:bg-primary font-bold rounded-full py-2 px-4 transition-colors",

  //44px
  secondary_m:
    "w-auto h-[40px] lg:h-[44px] flex items-center justify-center bg-transparent hover:bg-primary border border-primary text-primary hover:text-white text-lg font-semibold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //56px
  secondary_l:
    "h-[56px] flex items-center justify-center border border-primary text-primary text-lg lg:text-xl hover:text-white hover:bg-primary font-bold rounded-full py-2 px-4 transition-colors",

  //40px inv
  secondary_inv:
    "h-[40px] flex items-center justify-center border border-white/30 text-white hover:bg-white/10 font-bold rounded-full py-2 px-4 backdrop-blur-sm transition",

  //56px inv
  secondary_l_inv:
    "w-auto h-[48px] lg:h-[56px] flex items-center justify-center gap-2 bg-transparent border border-white hover:scale-105 text-white text-[20px] font-semibold whitespace-nowrap rounded-full px-7 lg:px-[34px] transition",

  //40px red
  secondary_red:
    "h-[40px] flex items-center justify-center border border-error text-error hover:text-white hover:bg-error font-bold rounded-full py-2 px-4 transition-colors",

  // Text buttons ----------------------------------------->
  text_btn: 
    "flex items-center justify-center text-text_secondary hover:text-primary hover:underline font-medium text-sm md:text-base transition-colors px-1 py-2",

  text_btn_primary: 
    "flex items-center justify-center text-primary hover:underline font-medium text-sm md:text-base transition px-1 py-2",

  text_btn_ghost:
    "flex items-center justify-center text-text_secondary hover:text-text font-medium text-xs md:text-sm transition-colors px-3 py-2",

  // Icon buttons ----------------------------------------->
  // Gray color icons
  icon: 
    "h-[40px] flex items-center justify-center border-0 font-bold py-2 px-4 rounded text-text_secondary hover:text-primary transition-colors",

  // Primary color icons
  icon_primary:
    "p-1.5 rounded-lg text-primary hover:text-primary_dk hover:bg-primary/5 shrink-0 transition disabled:opacity-50 disabled:cursor-not-allowed",

  // For the Close btn
  close_icon: 
    "w-8 h-8 flex items-center justify-center rounded-full text-text_secondary hover:text-text hover:bg-neutral transition-colors",

  // Like buttons (for Blog articles) --------------------->
  like_btn:
    "h-8 md:h-10 flex items-center justify-start gap-1 border-transparent hover:text-primary hover:border-b-2 hover:border-primary active:scale-95 transition-all duration-200 ease-in-out cursor-pointer focus:outline-none rounded-sm",

  like_btn_big:
    "w-auto h-[40px] md:h-[44px] lg:h-[48px] flex items-center justify-center border-[1px] border-primary hover:border-primary_hov bg-transparent text-primary text-[16px] font-normal hover:font-bold rounded-full px-[16px] md:px-[18px] xl:px-[20px] transition",

  // Sign In buttons ---------------------------------------->
  sign_in_option:
    "w-full max-w-[374px] h-[40px] flex items-center justify-center gap-2 bg-primary hover:bg-primary_hov text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  sign_in_option_disabled:
    "w-full max-w-[374px] h-[40px] flex items-center justify-center gap-2 border border-primary/30 text-primary/50 font-bold rounded-full py-2 px-4 cursor-not-allowed",
}
